import gql from 'graphql-tag';
import get from 'lodash/get';
import { compose, graphql } from 'react-apollo';
import { GetEmployeeDetails } from 'src/_shared/api/graphql/custom/users/';
import uuid from 'uuid/v4';
import { updateUser } from '../../graphql/custom/users';
import {
	createUserDepartment,
	deleteUserDepartment,
} from '../../graphql/default';

export const withUserById = (Component, variables) => {
	return compose(
		graphql(gql(GetEmployeeDetails), {
			options: {
				context: {
					headers: {
						'x-frame-options': 'deny', // This header will reach the server
					},
				},
				variables,
				fetchPolicy: 'cache-and-network',
			},
			props: (props) => {
				const { loading, error, getUser } = props.data;

				if (loading) return { user: undefined, loading: true };

				if (error || !getUser) {
					return { user: null, error };
				}

				return {
					user: getUser,
				};
			},
		}),
		graphql(gql(updateUser), {
			props: ({ mutate, ownProps, result }) => ({
				onUpdate(input) {
					mutate({
						variables: input,
						update(apolloCache, mutationResult) {
							try {
								const cacheData = apolloCache.readQuery({
									query: gql(GetEmployeeDetails),
									context: {
										headers: {
											'x-frame-options': 'deny',
										},
									},
									variables: { id: ownProps?.user.id },
								});
								const newCacheData = {
									getUser: {
										...cacheData?.getUser,
										...input.input,
									},
								};

								apolloCache.writeQuery({
									query: gql(GetEmployeeDetails),
									context: {
										headers: {
											'x-frame-options': 'deny',
										},
									},
									data: newCacheData,
									variables: { id: ownProps?.user.id },
								});
							} catch (error) {
								console.log('onUpdate user ERROR:\n', error);
							}
						},
					});
				},
			}),
		}),
		graphql(gql(createUserDepartment), {
			props: (props) => ({
				onAddDepartment(input) {
					const optimisticResponseData = {
						...input,
						id: uuid(),
						user: props.ownProps.user,
						department: get(props, 'ownProps.departments', []).find(
							(dept) => dept.id === input.departmentId
						),
					};

					props.mutate({
						variables: { input },
						optimisticResponse: {
							__typename: 'Mutation',
							createUserDepartment: {
								...optimisticResponseData,
								__typename: 'createUserDepartment',
							},
						},
						update(proxy, { data: { createUserDepartment } }) {
							const data = proxy.readQuery({
								query: gql(GetEmployeeDetails),
								variables: { id: input.userId },
							});

							// For some reason this update ran one too many times
							// those causing duplicates so let's check to see if it exists
							if (
								!data.getUser.managedDepartments.find(
									(dept) => dept.id === createUserDepartment.id
								)
							) {
								data.getUser.managedDepartments.push(createUserDepartment);
							}

							proxy.writeQuery({
								query: gql(GetEmployeeDetails),
								data,
								variables: { id: input.userId },
							});
						},
					});
				},
			}),
		}),
		graphql(gql(deleteUserDepartment), {
			props: (props) => ({
				onDeleteDepartment(input) {
					const deletedDepartment = props.ownProps.user.managedDepartments.find(
						(dept) => dept.id === input.input.id
					);
					const optimisticResponseData = {
						...input,
						...deletedDepartment,
						user: props.ownProps.user,
					};
					props.mutate({
						variables: input,
						optimisticResponse: {
							__typename: 'Mutation',
							deleteUserDepartment: {
								...optimisticResponseData,
							},
						},
						update(proxy, { data: { deleteUserDepartment } }) {
							const data = proxy.readQuery({
								query: gql(GetEmployeeDetails),
								variables: { id: props.ownProps.user.id },
							});
							data.getUser.managedDepartments =
								data.getUser.managedDepartments.filter(
									(dept) => dept.id !== deleteUserDepartment.id
								);
							proxy.writeQuery({
								query: gql(GetEmployeeDetails),
								data,
								variables: { id: props.ownProps.user.id },
							});
						},
					});
				},
			}),
		})
	)(Component);
};
